import {
  IArbitrage,
  IArbitrageBalancerOrder,
  IArbitrageConfig,
  IArbitrageInventories,
} from 'types/arbitrage';

import { AApiBase } from '../apiBase/AApiBase';
import { metricsAxios } from '../apiBase/axios';
import type { IBaseResponse } from '../apiBase/IBaseResponse';
import { mapError } from '../apiBase/mapError';
import { mapResponse } from '../apiBase/mapResponse';

class ApiArbitrage extends AApiBase {
  protected baseUrl = '/api';
  protected withHeader = true;

  /**
   * @deprecated Use getArbitrageConfigs from entities/arbitrage instead.
   */
  public static getArbitrageConfigs = async ({ projectId }: { projectId: number }) => {
    try {
      const response = await metricsAxios.get<IBaseResponse<IArbitrageConfig[]>>(
        `/api/v1/bot/arbitrage?project_id=${projectId}`,
      );
      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<IArbitrageConfig[]>({ error });
    }
  };

  public static updateArbitrageConfig = async (newConfig: IArbitrageConfig) => {
    try {
      const response = await metricsAxios.put<IBaseResponse<any>>(
        '/api/v1/bot/arbitrage',
        newConfig,
      );

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<any>({ error });
    }
  };

  public static createArbitrageConfig = async (newConfig: Omit<IArbitrageConfig, 'id'>) => {
    try {
      const response = await metricsAxios.post<IBaseResponse<{ id: number }>>(
        '/api/v1/bot/arbitrage',
        newConfig,
      );

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<{ id: number }>({ error });
    }
  };

  public static deleteArbitrageConfig = async (configId: number) => {
    try {
      const response = await metricsAxios.delete<IBaseResponse<any>>(
        `/api/v1/bot/arbitrage?config_id=${configId}`,
      );

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<any>({ error });
    }
  };

  /**
   * @deprecated no usages in the project
   */
  public static getArbitrageIntventories = async ({
    arbitrage_account_id,
  }: {
    arbitrage_account_id: number;
  }) => {
    try {
      const response = await metricsAxios.get<IBaseResponse<IArbitrageInventories>>(
        '/api/v1/bot/arbitrage/inventories',
        {
          params: {
            arbitrage_account_id,
          },
        },
      );

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<IArbitrageInventories>({ error });
    }
  };

  /**
   * @deprecated Use useGetArbitrageList instead
   */
  public static getArbitrageList = async ({
    arbitrage_account_id,
    limit,
    from_ms,
    offset,
    to_ms,
  }: {
    arbitrage_account_id: number;
    limit?: number;
    offset?: number;
    from_ms?: number;
    to_ms?: number;
  }) => {
    type ReturnType = {
      arbitrages: IArbitrage[];
      total_count: number;
    };

    try {
      const response = await metricsAxios.get<IBaseResponse<ReturnType>>(
        '/api/v1/bot/arbitrage/list',
        {
          params: {
            arbitrage_account_id,
            limit,
            from_ms,
            offset,
            to_ms,
          },
        },
      );

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<ReturnType>({ error });
    }
  };

  public static getArbitrageBalancerList = async ({
    arbitrage_account_id,
    limit,
    from_ms,
    offset,
    to_ms,
  }: {
    arbitrage_account_id: number;
    limit?: number;
    offset?: number;
    from_ms?: number;
    to_ms?: number;
  }) => {
    type ReturnType = {
      orders: IArbitrageBalancerOrder[];
      total_count: number;
    };

    try {
      const response = await metricsAxios.get<IBaseResponse<ReturnType>>(
        '/api/v1/bot/arbitrage/balancer-list',
        {
          params: {
            arbitrage_account_id,
            limit,
            from_ms,
            offset,
            to_ms,
          },
        },
      );

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<ReturnType>({ error });
    }
  };
}

export { ApiArbitrage };
